// IMPORTS
// OHS
import { OHSFormItem, OHSFormSelectBuilder } from '../../../../../onehivesystems/js/OHSForm';
// Assets
import { portTypes } from '../_variables';


// COMPONENT
export default function GeneralInformation (props) {
   return (
      <>
         <OHSFormItem onehive={props.onehive} title="Port Number">
            <input type='text' className='ohsinput' data-ohsformdata='name' defaultValue={props.parent.content.name.value} />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Port Type">
            <OHSFormSelectBuilder onehive={props.onehive} content={portTypes} selected={props.parent.content.port_type.value} simple={true} blank={false} ohsformdata='port_type' />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Mapped Device">
            <OHSFormSelectBuilder onehive={props.onehive} content={props.parent.devices} field={"name"} selected={props.parent.content.mapped_device.value} blank={true} ohsformdata='mapped_device' />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Expiration">
            <input type='datetime-local' className='ohsinput' data-ohsformdata='expiration' defaultValue={props.parent.content.expiration.value} />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Broken/Unusable">
            <input type='checkbox' className='ohsinput' data-ohsformdata='unusable' defaultChecked={Boolean(Number(props.parent.content.unusable.value))} />
         </OHSFormItem>
      </>
   );
}